import React, { useState } from "react";

// Функция генерации дат
const generateDates = () => {
  const today = new Date();
  const options = { weekday: "short" }; // 'Mon', 'Tue', ...
  return Array.from({ length: 9 }, (_, i) => {
    const d = new Date(today);
    d.setDate(today.getDate() + i);
    return {
      label: i === 0 ? "Today" : d.toLocaleDateString("en-US", options),
      date: d.getDate(),
    };
  });
};

const cinemas = [
  "1954 Film House",
  "Cinescape 360",
  "Cinescape Assima",
  "Cinescape Avenues",
  "Cinescape Al Kout",
  "Cinescape Khiran",
];

const times = ["16:45", "21:45", "00:15", "13:30", "11:15", "9:45", "19:15"];

export default function SelectDateTime() {
  const [activeDate, setActiveDate] = useState(0);
  const [activeCinema, setActiveCinema] = useState(0);
  const [activeTime, setActiveTime] = useState(null);
  const dates = generateDates();

  return (
    <div className="max-w-screen-xl mt-8 mx-auto px-6 py-12">
      <h2 className="text-2xl font-bold mb-6">Select Date & Time</h2>

      {/* Date selector */}
      <div className="flex gap-1 overflow-x-auto mb-3">
        {dates.map((d, i) => (
          <div
            key={i}
            onClick={() => setActiveDate(i)}
            className={`min-w-[80px] text-center px-4 py-3 border-r border-gray-300 cursor-pointer font-semibold ${
              i === activeDate
                ? "bg-red-600 text-white rounded-t-lg"
                : "text-black"
            }`}
          >
            <div className="text-sm">{d.label}</div>
            <div className="text-2xl font-light">{d.date}</div>
          </div>
        ))}
      </div>

      {/* Cinema selector */}
      <div className="flex flex-wrap bg-red-600 text-white text-lg overflow-x-auto">
        {cinemas.map((c, i) => (
          <div
            key={i}
            onClick={() => setActiveCinema(i)}
            className={`px-8 py-5 cursor-pointer border-r border-red-700 ${
              i === activeCinema ? "font-bold" : "opacity-60"
            }`}
          >
            {c}
          </div>
        ))}
        <div className="px-3 flex items-center"> </div>
      </div>

      {/* Times */}
      <div className="mt-10">
        <div className="flex gap-4 flex-wrap">
          {times.map((t, i) => (
            <button
              key={i}
              onClick={() => setActiveTime(i)}
              className={`px-8 py-2 border border-gray-300 rounded-2xl font-semibold transition-colors duration-200 ${
                activeTime === i
                  ? "bg-red-500 text-white"
                  : "hover:bg-red-500 hover:text-white"
              }`}
            >
              {t}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
